const base64ToBuffer = (data) => {
    var bString = window.atob(data);
    var bLength = bString.length;
    var bytes = new Uint8Array(bLength);
    for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
};

const downloadPDF = (base64, filename) => {
    var bufferArray = base64ToBuffer(base64); // get the base64encoded response from backend side
    var blobStore = new Blob([bufferArray], { type: "application/pdf" });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
    }
    var data = window.URL.createObjectURL(blobStore);
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.href = data;
    link.download = 'ETQ - ' + filename + ".pdf";
    link.click();
    window.URL.revokeObjectURL(data);
    link.remove();
}

export default downloadPDF;
